module.exports = __webpack_public_path__ + "img/02.981e35c2.jpg";